import React from "react";

import styles from "./css/mobile-menu-toggle.module.scss";

const MobileMenuToggle = () => (
  <button
    className={styles.toggle}
    onClick={() => window.dispatchEvent(new Event("open-mobile-sidebar"))}
    aria-label="Open menu"
    aria-expanded="false"
    type="button"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="12" viewBox="0 0 25 12" fill="none">
      <path d="M0 0.75H25" stroke="black" strokeWidth="1.5" />
      <path d="M0 10.75H25" stroke="black" strokeWidth="1.5" />
    </svg>
  </button>
);

export default MobileMenuToggle;
